import { Route } from '@angular/router';

export const appRoutes: Route[] = [
    {
        path: 'respond',
        loadChildren: () => import('@bx-web/respond').then((m) => m.RespondModule),
    },
    {
        path: '**',
        loadComponent: () => import('@bx-web/page-not-found').then((m) => m.PageNotFoundComponent),
    },
];
